"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagChip = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../atoms");

var _ = require("./");

var _excluded = ["category", "tag", "onClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TagChip = function TagChip(_ref) {
  var _tag$background;

  var category = _ref.category,
      tag = _ref.tag,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_.Chip, _extends({}, props, {
    key: "".concat(category, "-").concat(tag.name),
    trkAction: "Tag Pressed",
    onClick: onClick,
    background: (_tag$background = tag.background) !== null && _tag$background !== void 0 ? _tag$background : _atoms.Color.Grey4,
    prefix: tag.color ? /*#__PURE__*/_react.default.createElement(_atoms.Badge, {
      color: tag.color,
      position: _atoms.Badge.Position.Inline,
      size: 12,
      border: _atoms.Color.Grey3
    }) : null,
    icon: tag.icon,
    content: tag.title
  }));
};

exports.TagChip = TagChip;